<template>
  <div>
    <div class="productBanner"><Banner :classType="2" /></div>
    <Menu />

    <div
      class="pageTitle wow animate__slideInUp"
      :class="{ titleEn: lang == 'en' }"
    >
      <h2>研发核心</h2>
      <p>R&D CORE</p>
    </div>

    <div :key="idx" v-for="(item, idx) in list" class="wow animate__slideInUp">
      <div v-if="idx % 2 == 0" class="wrap productOne">
        <el-row :gutter="50" class="mlist1">
          <el-col :xs="24" :sm="24" :md="11" class="productTxt">
            <h3>{{ item.Title }}</h3>
            <p>
              {{ item.Summary }}
            </p>
          </el-col>
          <el-col :xs="24" :sm="24" :md="13"
            ><el-image
              class="productImg"
              :src="item.PicUrl"
              fit="cover"
            ></el-image
          ></el-col>
        </el-row>
      </div>

      <div v-else class="grey-bg wow animate__slideInUp">
        <div class="wrap productTwo">
          <el-row :gutter="50">
            <el-col :xs="24" :sm="24" :md="11"
              ><el-image
                class="productImg"
                :src="item.PicUrl"
                fit="cover"
              ></el-image
            ></el-col>
            <el-col :xs="24" :sm="24" :md="13" class="productTxt">
              <h3>{{ item.Title }}</h3>
              <p>
                {{ item.Summary }}
              </p>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <!-- <div class="wrap productOne wow animate__slideInUp">
      <el-row type="flex" :gutter="50">
        <el-col :span="11" class="productTxt">
          <h3>四大核心技术体系</h3>
          <p>
            中复神鹰在国内率先实现高性能干喷湿纺碳纤维产业化，形成了“大容量聚合与均质化原液制备技术”、“高强/中模碳纤维原丝干喷湿纺关键技术”、“PAN纤维快速均质预氧化、碳化集成技术”、“干喷湿纺千吨级高强/百吨级中模碳纤维产业化生产体系构建技术”四大核心技术体系。
          </p>
        </el-col>
        <el-col :span="13"
          ><el-image
            :src="require('@/assets/images/product1.jpg')"
            fit="cover"
          ></el-image
        ></el-col>
      </el-row>
    </div>

    <div class="grey-bg wow animate__slideInUp">
      <div class="wrap productTwo">
        <el-row type="flex" :gutter="50">
          <el-col :span="11"
            ><el-image
              :src="require('@/assets/images/product1.jpg')"
              fit="cover"
            ></el-image
          ></el-col>
          <el-col :span="13" class="productTxt">
            <h3>国内首条千吨级干喷湿纺 碳纤维产业化生产线</h3>
            <p>
              公司不断突破碳纤维的技术瓶颈，系统掌握了碳纤维T700级、T800级、M30级、M35级千吨级技术和M40级、T1000级百吨级技术，建成了国内首条具有自主知识产权的千吨级干喷湿纺碳纤维产业化生产线。
            </p>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="wrap productOne wow animate__slideInUp">
      <el-row type="flex" :gutter="50">
        <el-col :span="11" class="productTxt">
          <h3>技术领先</h3>
          <p>
            目前已取得67项授权专利，其中发明专利26项，以主要起草单位身份2次参与《聚丙烯腈基碳纤维》国家标准的制定，1次参与《聚丙烯腈基碳纤维原丝》行业标准的制定。2017年公司“干喷湿纺千吨级高强/百吨级中模碳纤维产业化关键技术及应用”成果荣获国家科学技术进步一等奖，为国内碳纤维领域唯一获得该项殊荣的企业，进一步奠定了公司在国内碳纤维领域的技术领先地位。
          </p>
        </el-col>
        <el-col :span="13"
          ><el-image
            :src="require('@/assets/images/product3.jpg')"
            fit="cover"
          ></el-image
        ></el-col>
      </el-row>
    </div>

    <div class="grey-bg wow animate__slideInUp">
      <div class="wrap productTwo">
        <el-row type="flex" :gutter="50">
          <el-col :span="11"
            ><el-image
              :src="require('@/assets/images/product4.jpg')"
              fit="cover"
            ></el-image
          ></el-col>
          <el-col :span="13" class="productTxt">
            <h3>力臻卓越</h3>
            <p>
              根据国家重大战略需求及公司研发规划，公司正在集中技术力量开展新一代高强/高模的高性能碳纤维、M50J及以上高模量碳纤维、T800级航空级预浸料等新产品新技术研发工作，深入践行创新引领发展战略，实现碳纤维技术整体达到国际前列。
            </p>
          </el-col>
        </el-row>
      </div>
    </div> -->
  </div>
</template>

<script>
import Menu from "./Menu.vue";
import Banner from "@/views/components/Banner";
import { WOW } from "wowjs";

export default {
  data() {
    return {
      list: [],
      lang: this.$global.lang,
    };
  },
  components: {
    Menu,
    Banner,
  },
  mounted() {
    this.$api
      .rearch({
        Type: 1,
      })
      .then((res) => {
        const { ContentInfos } = res.Value;
        this.list = ContentInfos;
        this.$nextTick(() => {
          new WOW({
            boxClass: "wow",
            animateClass: "animate__animated",
            live: false,
          }).init();
        });
      });
  },
};
</script>

<style lang="scss">
</style>